"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _set2 = _interopRequireDefault(require("@babel/runtime/helpers/set"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var Survey = _interopRequireWildcard(require("survey-core"));
var _constants = _interopRequireDefault(require("../../../constants"));
var _constants2 = require("../constants");
var _customQuestionDateTime = require("../date/customQuestionDateTime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var QuestionDateModel = /*#__PURE__*/function (_Survey$QuestionTextM) {
  (0, _inherits2.default)(QuestionDateModel, _Survey$QuestionTextM);
  var _super = _createSuper(QuestionDateModel);
  function QuestionDateModel() {
    var _this;
    (0, _classCallCheck2.default)(this, QuestionDateModel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getType", function () {
      return 'dateCustom';
    });
    return _this;
  }
  (0, _createClass2.default)(QuestionDateModel, [{
    key: "isVisible",
    get: function get() {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(QuestionDateModel.prototype), "visible", this) || this.isDesignMode;
    }
  }, {
    key: "visible",
    get: function get() {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(QuestionDateModel.prototype), "visible", this);
    },
    set: function set(value) {
      (0, _set2.default)((0, _getPrototypeOf2.default)(QuestionDateModel.prototype), "visible", value, this, true);
    }

    /**
     * Override Survey method to handle format of the value
     * Just change the function inside with name "func"
     * @param {} expression
     * @param {} defaultValue
     * @param {} setFunc
     * @param {} values
     * @param {} properties
     */
  }, {
    key: "setValueAndRunExpression",
    value: function setValueAndRunExpression(expression, defaultValue, setFunc, values, properties) {
      var _this2 = this;
      var func = function func(val, internalType) {
        var newValue = val;
        if (val instanceof Date) {
          var formatValue = (0, _customQuestionDateTime.getDateFormat)({
            internalType: internalType
          });
          newValue = (0, _customQuestionDateTime.convertValueToSet)((0, _momentTimezone.default)(val).format(formatValue), formatValue, internalType);
        }
        setFunc(newValue);
      };
      var newValues = values;
      var newProperties = properties;
      if (!!expression && !!this.data) {
        if (!values) newValues = this.data.getFilteredValues();
        if (!properties) newProperties = this.data.getFilteredProperties();
        var runner = new Survey.ExpressionRunner(expression);
        if (runner.canRun) {
          runner.onRunComplete = function (res) {
            var newRes = res;
            if (res === undefined) newRes = _this2.defaultValue;
            func(newRes, _this2.internalType);
          };
          runner.run(newValues, newProperties);
        }
      } else {
        func(defaultValue, this.internalType);
      }
    }

    /**
     * Override getCalculatedMinMax
     * @param {*} minMax
     * @returns Date
     */
  }, {
    key: "getCalculatedMinMax",
    value: function getCalculatedMinMax(minMax) {
      if (this.isValueEmpty(minMax)) return minMax;
      if (this.isDateInputType) {
        var date = new Date(minMax);
        if (this.internalType === _constants2.DATE_TYPE.DATE) {
          date.setHours(0, 0, 0, 0);
        }
        return date;
      }
      return minMax;
    }

    /**
     * Convert time value from 24H to 12H and show in error message
     */
  }, {
    key: "getMinMaxErrorText",
    value: function getMinMaxErrorText(errorText, value) {
      if (!value) return errorText;
      var newValue = value.toString();
      if (this.internalType === 'timeCustom') {
        newValue = (0, _customQuestionDateTime.convertValueToDisplay)(value.toString(), _constants.default.DateTimeFormat.shortTimeAMPM, _constants2.DATE_TYPE.TIME);
      } else if (this.internalType === 'dateTimeCustom') {
        newValue = (0, _momentTimezone.default)(value.toString()).format(_constants.default.DateTimeFormat.dateTimeAMPM);
      }
      return errorText.replace('{0}', newValue);
    }

    /**
     * Override Survey method to handle time format or min/max validator
     */
  }, {
    key: "onCheckForErrors",
    value: function onCheckForErrors(errors, isOnValueChanged) {
      if (this.internalType === 'timeCustom') {
        var inputRegex = this.customValue && this.customValue !== '' && this.customValue.match(_constants2.TIME_12H_FORMAT_REGEX);
        var defaultRegex = this.value && this.value !== '' && this.value.match(_constants2.TIME_24H_FORMAT_REGEX);
        // Call Survey error in cases
        // 1. value is undefined
        // 2. value is empty
        // 3. value correct 24h format and customValue is undefined
        // 4. value correct 24h format and customValue correct 12h format
        if (!this.value || this.value && this.value === '' || defaultRegex && (!this.customValue || inputRegex)) {
          (0, _get2.default)((0, _getPrototypeOf2.default)(QuestionDateModel.prototype), "onCheckForErrors", this).call(this, errors, isOnValueChanged);
        }
      } else {
        (0, _get2.default)((0, _getPrototypeOf2.default)(QuestionDateModel.prototype), "onCheckForErrors", this).call(this, errors, isOnValueChanged);
      }
    }
  }]);
  return QuestionDateModel;
}(Survey.QuestionTextModel);
var _default = QuestionDateModel;
exports.default = _default;